import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader } from 'app/components/ui/page-header'
import { PAGE_GUTTER, PageGutterContext } from 'app/components/layout/PageScroll'
import { cn } from 'app/lib/utils'
import type { LocationItem } from './usePmsSchedules'

export type PmsSchedulesComponentProps = {
  locations: LocationItem[]
}

export function PmsSchedulesComponent({ locations }: PmsSchedulesComponentProps) {
  const gutter = useContext(PageGutterContext)
  return (
    // Outside the settings well, `main` already carries the page gutter and top padding; inside
    // the well `main`'s gutter is stripped, so this wrapper takes over both only in that context.
    <div className={cn(gutter === `inset` && cn(PAGE_GUTTER.inset, `pt-8`))}>
      <PageHeader title="PMS Schedules" />
      <div className="bg-surface p-6 shadow">
        <h2 className="mb-4 text-xl font-semibold">Select a Location</h2>
        {locations.length === 0 ? (
          <div className="text-subtle">No locations in this workspace</div>
        ) : (
          <div className="space-y-2">
            {locations.map((location) => (
              <Link
                key={location.id}
                to={`/settings/pms-schedules/${location.id}`}
                className="block rounded border border-default p-4 hover:border-blue-500 hover:bg-blue-50"
              >
                <div className="text-lg font-medium">{location.name}</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
